module.exports = __webpack_public_path__ + "static/clothing-sandal-75f5b514310fb8f5bc4b699ad27271e9.jpg";